import { AuthProvider } from '@/contexts/AuthProvider';
import { AppRouter } from '@/router';

import type { JSX } from 'react';

export function App(): JSX.Element {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
